// steps.data.js
export const sections = [
  { id: "intro", label: "Bienvenue" },
  { id: "connexion", label: "Créer son compte utilisateur" },
  { id: "megamenu", label: "Découvrir le Menu Application" },
  { id: "utilisateurs", label: "Les Pages Utilisateurs" },
  { id: "enseignants", label: "Les Pages Enseignants" },
  { id: "administrateurs", label: "Les Pages Administrateurs" },
];

export const steps = {
  connexion: [
    {
      title: "Créer son compte utilisateur",
      text: "Cette application web vous permet d'afficher des pages personnalisées. ... Un compte utilisateur permet de gérer un ou plusieurs adhérents, un adhérent peut être géré par un ou plusieurs utilisateurs.",
      img: "/img/Tutoriel/connexion_01.png",
    },
    {
      title: "Email déjà utilisé lors de la création du compte",
      text: "Je tombe sur ce message d'erreur : Le mail est déjà enregistré... Il faudra donc réinitialiser votre mot de passe.",
      img: "/img/Tutoriel/connexion_02.png",
    },
    {
      title: "Se connecter",
      text: "Saisissez votre email et votre mot de passe. En cas d’oubli, utilisez « Mot de passe oublié »... ",
      img: "/img/Tutoriel/connexion_03.png",
    },
  ],
  megamenu: [
    {
      title: "Le Bouton Application",
      text: "Une fois connecté, vous verrez apparaître un bouton Application à côté du bouton Menu. Celui-ci vous permettra d'accéder à des pages personnalisées en fonction de votre rôle. Par défaut lorsque l'on se connecte pour la première fois, on a le rôle d'utilisateur. Seul l'administrateur peut vous changer de rôle (Enseignant, Administrateur)",
      img: "/img/Tutoriel/megamenu01.png",
    },
    {
      title: "Megamenu Utilisateur",
      text: "L'ouverture du Mégamenu affiche des tuiles correspondant aux différentes sections et pages accéssibles selon votre rôle. Voici le Megamenu pour les utilisateurs.",
      img: "/img/Tutoriel/megamenu02.png",
    },
    {
      title: "Megamenu Enseignant",
      text: "Voici le Megamenu pour les enseignants.",
      img: "/img/Tutoriel/megamenu03.png",
    },
    {
      title: "Megamenu Administrateur",
      text: "Voici le Megamenu pour les administrateurs. Vous avez la possibilité de recherche de page, ainsi qu'un système de favoris pour visualiser plus facilement vos pages",
      img: "/img/Tutoriel/megamenu04.png",
    },
  ],
  utilisateurs: [
    {
      title: "Inscription d'un Adhérent",
      text: "Ne pas confondre un compte utilisateur avec un adhérent. Un compte utilisateur permet de gérer un ou plusieurs adhérents inscrits sur le club. Dans le menu du site, vous avez accès à Inscription d'un Adhérent. Sur cette page inscription, vous visualisez les adhérents que vous gérer déjà. Si vous souhaitez ajouter un nouvel adhérent, remplissez le formulaire d'inscription. Choisissez un premier lieu si c'est pour une inscription ou un cours d'essai, ensuite précisez le dojo, le ou les clubs sur lesquels vous souhaitez inscrire l'adhérent. N'oubliez pas d'appuyer sur 'je m'inscris' . Ensuite poursuivez avec les différents champs du formulaire. Certains champs sont obligatoires.",
      img: "/img/Tutoriel/utilisateurs01.png",
    },
    {
      title: "Le Dossier d'inscription",
      text: "Une fois l'inscription de l'adhérent réalisé, vous êtes redirigé vers la page Dossier d'Inscription. C'est ici que vous allez gérer les documents nécessaires lors d'une inscription : certificat médical ou attestation santé, formulaire de licence-assurance à signer, ....  Vous verrez l'évolution sur chaque étape. Vous pourrez déposer vos documents soit en interne dans l'application soit par un lien type Google Drive. La validation des différentes sections : médical, licence-assurance et Règlement n'est pas automatique. Seuls le bureau peut valider après vérification des éléments transmis ou règlements effectués. Sur cette page, vous avez accès également à un dossier partagé Google Drive (si l'administrateur l'a configuré), vous pouvez signaler que vous avez déposé un document (l'administrateur reçoit une notification). Après finalisation du règlement, une attestation d'inscription est disponible et téléchargeable en pdf. Dans la partie basse de cette page, vous retrouvez toutes les informations utiles et fichiers nécessaires à télécharger.",
      img: "/img/Tutoriel/utilisateurs02.png",
    },
    {
      title: "Le Règlement en ligne",
      text: "Si vous avez choisi le règlement en ligne sur la page Dossier Inscription (Règlement), vous pourrez effectuer votre paiement en ligne de manière sécurisée sur la page Commande & Règlements. Sur cette page vous pouvez régler les achats des articles commandés en boutique, mais également les licences-cotisations pour la saison actuelle proposés par le bureau. Si vous ne voyez pas encore de Licences-Cotisations disponibles, cela signifie que l'administrateur ne vous l'a pas encore envoyé. Si les boutons de paiements sont inactifs, cela signifie que l'administrateur ne permet pas encore le règlement en ligne. Sur les licences-cotisations vous avez la possibilité d'étaler les règlements selon les modalités du club, une notification de rappel sera envoyé dans l'application pour les prochaines échéances.",
      img: "/img/Tutoriel/utilisateurs03.png",
    },
    {
      title: "La Fiche Adhérent",
      text: "Cette page permet de visualiser l'ensemble des données relatives à un adhérent : Coordonnées transmises que vous pouvez éditer, vos groupes & catégories, les utilisateurs associés, les passages de ceinture, les inscriptions aux compétitions, les résultats et palmarès, le dossier d'inscription, les règlements d'inscription, les derniers achats de l'utilisateur, les présences et absences.",
      img: "/img/Tutoriel/utilisateurs04.png",
    },
    {
      title: "Signaler une absence prolongée",
      text: "Pour signaler une absence prolongée (maladie, blessure, ...), vous pouvez remplir le formulaire d'absence. L'enseignant verra lors de l'appel sur son groupe une icône permettant de visualiser les absences prolongées.",
      img: "/img/Tutoriel/utilisateurs05.png",
    },
    {
      title: "Le Calendrier des événements",
      text: "Cette page vous permet de consulter l'ensemble des événements à venir, et également permet de se pré-inscrire sur une compétition. L'enseignant reçoit une notification pour chaque pré-inscription et valide après inscription sur extranet par exemple. De nombreux filtres et favoris permettent de trouver facilement l'événement qui correspond à vos attentes.",
      img: "/img/Tutoriel/utilisateurs06.png",
    },
    {
      title: "Communication : Messagerie et Discussions de groupes",
      text: "Sur cette application, vous pouvez échanger des messages avec les enseignants et les membres du bureau via la messagerie. Egalement, un systeme de discussion de groupe est disponible pour faciliter les échanges entre les adhérents ou parents du même groupe.",
      img: "/img/Tutoriel/utilisateurs07.png",
    },
    {
      title: "Autres pages disponibles pour les adhérents",
      text: "Vous pouvez retrouver de nombreuses pages : la boutique en ligne / les exercices de préparation physique envoyés par les enseignants / les actualités du club et Galeries Photos / le support technique qui comprend lexique, arbitrage, techniques et quizz / un page de sondage et test / une page présentant l'ensemble des applications disponibles pour les judokas.",
      img: "/img/Tutoriel/utilisateurs08.png",
    },
  ],
  enseignants: [
    {
      title: "Les pages Enseignants",
      text: "à compléter.",
      img: "/img/Tutoriel/inscription.jpg",
    },
  ],
  administrateurs: [
    {
      title: "Les pages Administrateurs",
      text: "à compléter",
      img: "/img/Tutoriel/payment.jpg",
    },
  ],
};

export const faqs = [
  {
    q: "Je ne reçois pas l’email d’activation.",
    a: "Vérifiez vos spams... demandez un nouvel envoi depuis l’écran de connexion.",
  },
  {
    q: "Comment changer de langue ?",
    a: "Ouvrez Profil → Préférences → Langue et sélectionnez votre langue...",
  },
  {
    q: "Puis-je payer en plusieurs fois ?",
    a: "Si le club l’autorise, l’option s’affiche au moment du paiement...",
  },
  {
    q: "Mes documents sont-ils sécurisés ?",
    a: "Oui. Les documents sont chiffrés et uniquement accessibles aux responsables habilités.",
  },
];
